import Checkbox from '@grnhse/seedling/lib/birch/components/checkbox';
import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.rediscovery.filter_row.exclusions');

const ExcludeRejectedCheckbox = () => {
  const { watch, setValue } = useFormContext();
  const excludeRejected = watch('exclude_rejected');

  return (
    <Checkbox
      data-provides={'talent-matching-exclude-rejected-checkbox'}
      checked={excludeRejected}
      onChange={(checked) =>
        setValue('exclude_rejected', checked, { shouldDirty: true })
      }
      label={t('rejected_from_this_job')}
      value={'exclude_rejected'}
    />
  );
};

export default ExcludeRejectedCheckbox;
